module.exports = __webpack_public_path__ + "static/bon-voyayge-e77747cfeaf7a29549c6e544d465d571.png";